import { Utils } from './utils'
import { deepClone, isEmptyArray, isNull, isNullObj, uniqueArray, msgboxWarning } from './validateBase'
import axios from 'axios'; // 引入axios
import { payDTO, CommonDTO } from '@/DTO/index'
import req from '@/utils/request';
import { queryDrug } from '@/api/common'
const service = axios.create({
  baseURL: '', // 请求本地json文件，那么baseURL取空字符串，域名就会是项目域名
  // timeout: 1000,
  timeout: 30000,
});
// 定义医保结算请求的参数
let orderNumber = null;
let orderPayNumber = null;
let ybPrePayObj = {}
let insuTypeList = []
let paymentOrderNums = []
let diseinfos = []
export function initData() {
  orderNumber = null;
  orderPayNumber = null;
  ybPrePayObj = {}
  insuTypeList = []
  paymentOrderNums = []
  diseinfos = []
}
// 结算调用
export async function settlementCall(_this) {
  let { code } = await handlePrePay(_this) //先调用预支付保存预支付信息
  if (code == 200) {
    _this.settlementLoadingText = '结算中'
    let orderParams = {
      certno: _this.yibaoObj.baseinfo.certno, //证件号码
      psn_no: _this.yibaoObj.baseinfo.psn_no, //人员编号
      mdtrt_id: _this.request_2204Obj.request_2204[0].mdtrt_id, //就诊编号
      mdtrt_cert_type: _this.yibaoObj.mdtrt_cert_type, //就诊凭证类型
      mdtrt_cert_no: _this.yibaoObj.mdtrt_cert_no, //就诊凭证编号
      discount_amount: 0, //优惠金额
      sum_amount: _this.yibaoObj.sum_amount, //累计金额
      card_token: _this.yibaoObj.card_token, //校验介质
      insutype: _this.yibaoObj.insuinfoObj.insutype, //险种类型
      insuplc_admdvs: _this.yibaoObj.insuinfoObj.insuplc_admdvs, //就诊人员参保地医保区划
      orderPayNumber: orderPayNumber,
      acct_used_flag: _this.is_wlt_acct,
      wlt_acct_flag: _this.is_wlt_acct,//钱包账户使用标志	字符型	3		Y	0 不使用 1 使用
      minpacunt_drug_trac_cnt: _this.minpacuntDrugTracCnt
    }
    console.log(' 结算调用-------------------', orderParams)
    let param = {
      method: "post",
      url: `${_this.$shebaoUrl}/settlement`,
      data: orderParams,
      // timeout: 300,
    }
    var success = async function (res, resolve) {
      let price = deepClone(_this.yibaoObj.sum_amount)
      let obj = {
        orderNumber: orderNumber,
        orderPayNumber: orderPayNumber,
        request_2204Obj: _this.request_2204Obj,
        price: price,
        items: _this.yibaoObj.items,
        payWay: '1'
      }
      if (res.data.code == 200) {
        obj.paySuccess = '1'
        obj.attach = { ...handleSetlinfo(res.data.data.setlinfo, _this.yibaoObj.relation, _this.yibaoObj.insuinfoObj), detailList: _this.multipleSelection }
        console.log('订单结算接口调用成功 --- 医保支付！', res.data);
        let { fund_pay_sumamt, psn_cash_pay, acct_pay, exp_content_obj } = res.data.data.setlinfo
        // 处理划价支付参数
        _this.setlinfo = res.data.data.setlinfo
        _this.setldetail = res.data.data.setldetail
        _this.settlementLoadingText = '数据保存中'
        if (Utils.eq(psn_cash_pay, 0) && !isNull(psn_cash_pay)) {
          // 医保账户余额足够
          _this.$emit('yibaoPay', obj)
        } else {
          let time = await CommonDTO.getSystemTimeDTO()
          let yibaoPrice = _this.$bigNumber(fund_pay_sumamt, '+', acct_pay) //医保实际扣款 acct_pay 已包含钱包支付
          _this.$message.success(`医保成功支付${yibaoPrice}元`)
          let callbackObj = {
            orderPayNumber: orderPayNumber, payTime: _this.$moment(time).format('YYYY-MM-DD HH:mm:ss'),
            paySuccess: '1', amount: yibaoPrice, attach: obj.attach
          }
          await payDTO.payCallback(callbackObj).then(callbackRes => {
            if (callbackRes.code == 200) {
              _this.dialogShow = false;
              _this.gjDialogShow = true;
            }
          })
        }
      } else {
        obj.paySuccess = '2'
        _this.$emit('yibaoPay', obj)
      }
      console.log('success end');
      resolve()
    }
    return new Promise((resolve, reject) => {
      axios(param).then(res => { success(res, resolve); }).catch(err => {
        let param = {
          orderNumber: orderNumber,
          orderPayNumber: orderPayNumber,
          request_2204Obj: _this.request_2204Obj,
          price: _this.yibaoObj.sum_amount,
          items: _this.yibaoObj.items,
          payWay: '1',
          paySuccess: '2'
        }
        _this.$message.error('医保错误或超时，请重试')
        _this.loading = false;
        _this.dialogShow = false;
        _this.settlementLoading = false;
        payDTO.payCallback(param).then(res => {
          //TODO  暂时无法处理 不清楚医保的超时时间
        })


      })
      console.log('结算调用完成');
    })
  }
}

//预支付
function handlePrePay(_this) {
  _this.settlementLoading = true;
  _this.settlementLoadingText = '保存记录'
  let preParams = {
    deptId: _this.$session.get('deptId'),
    ctOrderIds: _this.ctOrderIds,
    amount: _this.yibaoObj.sum_amount,
    payWay: '1',
    isMutualAidPay: false,//是否共济
  }
  preParams.attach = { ...handleSetlinfo(ybPrePayObj.setlinfo, _this.yibaoObj.relation, _this.yibaoObj.insuinfoObj), detailList: _this.multipleSelection }
  return new Promise((resolve, reject) => {
    payDTO.prePay(preParams).then(preRes => {
      _this.loadingText = '数据保存中'
      if (preRes.code == 200) {
        console.log('預支付調用成功', preRes);
        orderNumber = preRes.data.orderNumber;
        orderPayNumber = preRes.data.orderPayNumber;
        _this.orderNumber = orderNumber
        _this.orderPayNumber = orderPayNumber
        resolve({ code: 200 })
      } else {
        _this.loading = false;
        _this.dialogShow = false;
        _this.settlementLoading = false;
        resolve({ code: 500 })
      }
    }).catch(err => {
      _this.loading = false;
      _this.dialogShow = false;
      _this.settlementLoading = false;
      resolve({ code: 500 })
    })
  })

}

// 信息上传
function infoUpLoad(_this) {
  try {
    _this.loading = true
    _this.loadingText = '信息上传中'
    if (isNullObj(_this.yibaoObj)) {
      _this.$message('请重新刷卡')
      _this.cancel()
      _this.loading = false
      return;
    }
    let diagnosisList = deepClone(_this.diagnosisList)
    diseinfos = []
    if (isEmptyArray(diagnosisList)) {
      diseinfos.push({
        diag_code: 'Z51.901',
        diag_name: '对症治疗',
        diag_dept: '中医科', // 诊断科室,
        dise_dor_no: _this.yibaoObj.doctorCode ?  _this.yibaoObj.doctorId : _this.yibaoObj.doctorCode, // 诊断医生编码
        dise_dor_name: _this.yibaoObj.doctorName, // 诊断医生姓名
        diag_time: _this.$timeRange.nowTimes, // 诊断时间 日期时间型 yyyy-MM-dd HH:mm:ss
      })
    } else {
      diagnosisList.forEach(item => {
        diseinfos.push({
          diag_code: item.diagnoseCode,
          diag_name: item.diagnoseName,
          diag_dept: '中医科', // 诊断科室,
          dise_dor_no: _this.yibaoObj.doctorCode ?  _this.yibaoObj.doctorId : _this.yibaoObj.doctorCode, // 诊断医生编码
          dise_dor_name: _this.yibaoObj.doctorName, // 诊断医生姓名
          diag_time: _this.$timeRange.nowTimes, // 诊断时间 日期时间型 yyyy-MM-dd HH:mm:ss
        })
      })
    }
    diseinfos = uniqueArray(diseinfos, 'diag_code')
    // 信息上传参数
    let infoUploadParams = {
      certno: _this.yibaoObj.baseinfo.certno, // 身份证号码,
      psn_no: _this.yibaoObj.baseinfo.psn_no, //人员编号
      mdtrt_cert_type: _this.yibaoObj.mdtrt_cert_type, //就诊凭证类型
      mdtrt_cert_no: _this.yibaoObj.mdtrt_cert_no, //就诊凭证编号
      insutype: _this.yibaoObj.insuinfoObj.insutype, //险种类型
      card_token: _this.yibaoObj.card_token, //校验介质
      insuplc_admdvs: _this.yibaoObj.insuinfoObj.insuplc_admdvs, //就诊人员参保地医保区划
      wlt_acct_flag: _this.is_wlt_acct, //钱包账户使用标志	字符型	3		Y	0 不使用 1 使用
      request_2201: { // 挂号信息
        ipt_otp_no: (isNull(_this.yibaoObj.items) || isNull(_this.yibaoObj.items[0].rxno)) ? '' : _this.yibaoObj.items[0].rxno, // 住院/门诊号
        atddr_no: isNull(_this.yibaoObj.doctorCode) ? '' : _this.yibaoObj.doctorCode, // 医师编码
        dr_name: _this.yibaoObj.doctorName, // 医师姓名
        dept_code: 'ZYK', // 科室编码
        dept_name: '中医科', // 科室名称 
      },
      request_2203A: { // 诊断信息
        main_cond_dscr: _this.yibaoObj.diagnosis, // 主要病情描述
        begntime: _this.$timeRange.nowTimes, // 开始时间 yyyy-MM-dd HH:mm:ss
        diseinfos: diseinfos
      },
      request_2204: { // 费用明细
        fee_ocur_time: _this.$timeRange.nowTimes, // 支付时间
        bilg_dept_codg: '01', // 开单科室编码
        bilg_dept_name: '中医科', // 开单科室名称
        bilg_dr_codg: _this.yibaoObj.doctorId, // 开单医生编码
        bilg_dr_name: _this.yibaoObj.doctorName, // 开单医师姓名
        items: _this.multipleSelection, // 收费项目明细
      }
    }
    console.log('信息上次接口-------------------', infoUploadParams)

    let param = {
      method: "post",
      url: `${_this.$shebaoUrl}/upload_data`,
      data: infoUploadParams,
    }
    let axiosFun = function () {
      return new Promise((resolve, reject) => {
        axios(param).then(res => {
          resolve(res)
        }).catch(err => {
          _this.loading = false
        })
      })
    }
    let success = async function (res) {
      console.log('信息上传接口调用成功 --- 类似开方！', res.data);
      _this.yibaoStept = 2
      _this.request_2204Obj = res.data.data
      if (!isNull(res.data.data) && !isEmptyArray(res.data.data.request_2204[0])) {
        infoUploadParams.request_2204.items.forEach(v => {
          v.org_id = _this.$session.get('ybDeptNum')
          v.mdtrt_id = res.data.data.request_2204[0].mdtrt_id
        })
        req.post(`/chs/yb/pushYb2204`, { orderId: paymentOrderNums, yb2204s: infoUploadParams.request_2204.items }).then(async response => {
          if (response.code == 200) {
            let chsInfo = _this.$session.get('deptInfo').chsInfo
            if (chsInfo.beforeAnalyze == 1) {
              let isViolation = await beforeAnalyze(_this)
              if (isViolation) {
                await preSettlement(res.data.data.request_2204[0].mdtrt_id, _this); // 预结算调用
              }
            } else {
              await preSettlement(res.data.data.request_2204[0].mdtrt_id, _this); // 预结算调用
            }
          } else {
            _this.loading = false
          }
        })
      }
      console.log('settlementCall End');
    }
    let errorFun = function (err) {
      _this.loading = false
    }
    work(axiosFun, success, errorFun);

  } catch (error) {
    console.log(error);
    _this.loading = false
    CommonDTO.saveLogDTO({ businessType: '1', errorMsg: error.message })
  }


}
// 退款
export async function cancelSettlement(preObj, payObj, _this) {
  return new Promise((resolve, reject) => {
    let params = {
      setl_id: payObj.attach.setlId, // 结算ID
      mdtrt_id: payObj.attach.mdtrtId, // 就诊ID
      psn_no: payObj.attach.psnNo, // 人员编号
      certno: payObj.attach.certno, // 身份证
      insuplc_admdvs: payObj.attach.insuplcAdmdvs //就诊人员参保地医保区划
    };
    preObj.attach = {}
    payDTO.preRefund(preObj).then(async preRes => {
      if (preRes.code == 200) {
        params.refundNumber = preRes.data.refundNumber
        // 退款
        let time = await CommonDTO.getSystemTimeDTO()
        let obj = {
          refundNumber: preRes.data.refundNumber,
          amount: preRes.data.preRefundAmount,
          refundTime: _this.$moment(time).format('YYYY-MM-DD HH:mm:ss'),
          reason: payObj.refundReason,
        }
        axios({
          method: "post",
          url: `${_this.$shebaoUrl}/repeal_settlement`,
          data: JSON.stringify(params),
        }).then(async res => {
          if (res.data.code == 200) {
            obj.refundStatus = '1'
            // console.log(handleRefundSetlinfo(res.data.data.setlinfo),2222222);
            obj.attach = handleRefundSetlinfo(res.data.data.setlinfo).setlinfoObj
            payDTO.refundCallback(obj).then(async refundRes => {
              if (refundRes.code == 200) {
                _this.$message.success('医保退款成功！')
                resolve()
              } else {
                _this.loading = false
                _this.$message.error('医保退费失败，请到退费管理重试')
                _this.$emit('updateData')
              }
            })
          } else {
            obj.refundStatus = '2'
            obj.attach = {}
            payDTO.refundCallback(obj).then(async refundRes => { })
            _this.loading = false
          }
        }).catch(err => {
          obj.refundStatus = '2'
          obj.attach = {}
          payDTO.refundCallback(obj).then(async refundRes => { })
          _this.loading = false
          _this.$message.error('医保退费失败，请到退费管理重试')
          _this.$emit('updateData')
        })
      } else {
        _this.loading = false
      }
    })
  })

}


let work = Utils.jugeYBExecute();

// 医保初始化
export function initYB(_this) {
  _this.yibaoObj = {}
  // _this.loading = true
  _this.loadingText = '查询人员信息'
  let param = {
    method: "post",
    url: `${this.$shebaoUrl}/query_person_info`,
  }
  axios(param).then(async res => {
    if (res.data.code == 200) {
      _this.yibaoStept = 1;
      let data = JSON.parse(JSON.stringify(res.data.data));
      //查询统计信息
      _this.cumObj = await queryCheckAccountTotal(data, _this)
      //人员慢特病备案查询
      queryDisease(data, _this).then(diseaseRes => {
        if (diseaseRes.code == 200) {
          let diseaseList = []
          diseaseRes.data && diseaseRes.data.forEach(v => {
            diseaseList.push(v.opsp_dise_name)
          })
          _this.disease = diseaseList.join(',')
        }
      })
      let insuinfoList = []
      CommonDTO.getDictOptions('psn_type').then(json1 => { // 获取医保类别json文件
        // 处理医保类别回显
        data.insuinfo.forEach(obj1 => {
          json1.forEach(item1 => {
            if (item1.code_value == obj1.psn_type) obj1.psn_typeStr = item1.code_name;
          });
        })
        CommonDTO.getDictOptions('insutype').then(json2 => { // 获取保险类型json文件
          insuTypeList = json2;
          data.insuinfo.forEach(item => {
            json2.forEach(obj => {
              if (item.insutype == obj.code_value) {
                insuinfoList.push({
                  ...item,
                  label: obj.code_name
                })

              }
            })
          })
          data.insuinfo = insutypeSort(insuinfoList)
          _this.yibaoObj = {
            ...data,
            doctorId: _this.doctorInfo.doctorId,
            doctorName: _this.doctorInfo.doctorName,
            doctorCode: isNull(_this.doctorInfo.doctorCode) ? '' : _this.doctorInfo.doctorCode,
            diagnosis: _this.diagnosis,
          };
          if (_this.patientInfo.patientName.trim() != data.baseinfo.psn_name.trim()) {
            _this.$message.error(`当前持卡人为${data.baseinfo.psn_name},仅允许使用患者本人的医保卡`);
            this.loading = false;
            _this.cancel()
            return;
          }
          // 如果年龄差大于5岁
          if (Math.abs(_this.$bigNumber(_this.patientInfo.age, '-', data.baseinfo.age, 2)) >= 5) {
            msgboxWarning(this, {
              message: `该患者年龄与医保信息不符，刷医保可能有违规风险，是否继续？`,
              confirmFn: () => {
                _this.yibaoObj.relation = '0'
                _this.yibaoObj.items = handleItems(_this)
                _this.$forceUpdate()
                _this.$nextTick(() => {
                  _this.yibaoObj.items.forEach(item => {
                    _this.$refs.multipleTable.$refs.customTable.toggleRowSelection(item);
                  })
                  _this.$refs['yibaoDialogRef-input'].focus();
                  _this.yibaoBtn = false
                  _this.loading = false
                })
                _this.yibaoObj.sum_amount = _this.computedTotalPrice()
                _this.yibaoObj.price = _this.yibaoObj.sum_amount
                _this.insuinfoList = data.insuinfo
                if (isNullObj(_this.registerObj)) {
                  // 挂号费
                  _this.insutype = data.insuinfo[0].insutype
                  _this.yibaoObj.insuinfoObj = data.insuinfo[0]
                  _this.insuranceDialogShow = true
                } else {
                  let balcFlag = _this.insuinfoList.some(item => { return Utils.ge(item.balc, _this.registerObj.price) })
                  if (balcFlag) {
                    _this.insutype = data.insuinfo[0].insutype
                    _this.yibaoObj.insuinfoObj = data.insuinfo[0]
                    _this.insuranceDialogShow = true
                  } else {
                    _this.$message.error('医保账户余额不足，请更换支付方式')
                    _this.cancel()
                  }
                }
              },
              cancelFn: () => {
                this.loading = false;
                _this.cancel()
              },
            });
          } else {
            _this.yibaoObj.relation = '0'
            _this.yibaoObj.items = handleItems(_this)
            _this.$forceUpdate()
            _this.$nextTick(() => {
              _this.yibaoObj.items.forEach(item => {
                _this.$refs.multipleTable.$refs.customTable.toggleRowSelection(item);
              })
              _this.$refs['yibaoDialogRef-input'].focus();
              _this.yibaoBtn = false
              _this.loading = false
            })
            _this.yibaoObj.sum_amount = _this.computedTotalPrice()
            _this.yibaoObj.price = _this.yibaoObj.sum_amount
            _this.insuinfoList = data.insuinfo
            if (isNullObj(_this.registerObj)) {
              // 挂号费
              _this.insutype = data.insuinfo[0].insutype
              _this.yibaoObj.insuinfoObj = data.insuinfo[0]
              _this.insuranceDialogShow = true
            } else {
              let balcFlag = _this.insuinfoList.some(item => { return Utils.ge(item.balc, _this.registerObj.price) })
              if (balcFlag) {
                _this.insutype = data.insuinfo[0].insutype
                _this.yibaoObj.insuinfoObj = data.insuinfo[0]
                _this.insuranceDialogShow = true
              } else {
                _this.$message.error('医保账户余额不足，请更换支付方式')
                _this.cancel()
              }
            }
          }

        });

      });

    } else {
      _this.loading = false
      _this.cancel()
    }
  }).catch(err => {
    _this.loading = false
  })
}
// 处理收费项目明细（个账）
export function handleItems(_this) {
  try {
    let items = []
    paymentOrderNums = []
    if (!isNull(_this.registerObj) && !isNullObj(_this.registerObj)) {
      items.push({
        feedetl_sn: _this.registerObj.orderNumber,
        med_list_codg: '001101000010000',
        medins_list_codg: '1200139',
        det_item_fee_sumamt: isNull(_this.registerObj.price) ? 0 : _this.registerObj.price,
        pric: isNull(_this.registerObj.price) ? 0 : _this.registerObj.price,
        cnt: 1,
        rxno: _this.registerObj.orderNumber,
        unit: '次',
        itemName: '挂号费',
        hosp_appr_flag: '1',
      })
    }
    if (!isNull(_this.recipesList) && !isEmptyArray(_this.recipesList)) {
      _this.recipesList.forEach(item => {
        paymentOrderNums.push(item.paymentOrderNum)
        if (!isNull(item.processFlag) && item.processFlag == '1' && !isNullObj(item.process)) {
          if (item.isYlcp == '1') {
            items.push({
              feedetl_sn: item.paymentOrderNum,
              med_list_codg: item.process.processDictDrugCode || '',
              medins_list_codg: isNull(item.process.processArtNo) ? '' : item.process.processArtNo,
              det_item_fee_sumamt: isNull(item.process.bargainProcessPrice) ? 0 : _this.$bigNumber(item.process.bargainProcessPrice, '*', item.doseNum, 2),
              pric: isNull(item.process.bargainProcessPrice) ? 0 : item.process.bargainProcessPrice,
              cnt: item.doseNum,
              rxno: item.paymentOrderNum,
              unit: '次',
              itemName: item.process.processName,
              paymentRecipeId: item.paymentRecipeId,
              hosp_appr_flag: '2',
              itemNum: 1,
              medicalInsuranceType: '3',
              spec: '次'
            });
          } else {
            items.push({
              feedetl_sn: item.paymentOrderNum,
              med_list_codg: item.process.processDictDrugCode || '',
              medins_list_codg: isNull(item.process.processArtNo) ? '' : item.process.processArtNo,
              det_item_fee_sumamt: isNull(item.process.bargainProcessPrice) ? 0 : item.process.bargainProcessPrice,
              pric: isNull(item.process.bargainProcessPrice) ? 0 : item.process.bargainProcessPrice,
              cnt: 1,
              rxno: item.paymentOrderNum,
              unit: '次',
              itemName: '加工费',
              paymentRecipeId: item.paymentRecipeId,
              hosp_appr_flag: '2',
              itemNum: 1,
              medicalInsuranceType: '3',
              spec: '次'
            });
          }

        }
        if (!isNull(item.items)) {
          // 中药
          if (item.recipeType == '1' && item.tcDoseNum && item.tcDoseNum > 0) {
            const tcDoseNum = item.tcDoseNum //可刷医保的剂量
            item.items.forEach(v => {
              const spuItemTotal = _this.$bigNumber(v.itemNum, '*', tcDoseNum)   //一个集合可刷医保的总数
              let hasSpuItemTotal = 0 //已经累计的可刷医保总数
              v.items.sort((a, b) => _this.$bigNumber(b.itemTotal, '-', a.itemTotal)); //对每个集合的项目按数量降序排序
              // 遍历每个items，从第一个开始取，直到数量大于等于可刷医保的总数
              v.items.forEach(item0 => {
                if ((!isNull(item0.dictDrugCode) && !isNull(item0.medicalInsuranceType) && (item0.medicalInsuranceType == '2' || item0.medicalInsuranceType == '3'))) {
                  let { artNo, dictDrugCode, itemTotal, itemUnit, itemName, bargainTotalPrice, bargainPrice, medicalInsuranceType, min_pac_cnt, min_pacunt } = item0;
                  let isgt = Utils.gt(bargainTotalPrice, 0)
                  if (isgt && item0.isOwned != '1') {
                    if (spuItemTotal >= hasSpuItemTotal) {
                      items.push({
                        feedetl_sn: item.paymentOrderNum,
                        med_list_codg: dictDrugCode,
                        medins_list_codg: artNo,
                        det_item_fee_sumamt: _this.$bigNumber(bargainPrice, '*', Math.min(itemTotal, spuItemTotal - hasSpuItemTotal),2), //折后总价
                        pric: bargainPrice, //单价
                        cnt: Math.min(itemTotal, spuItemTotal - hasSpuItemTotal), //数量 
                        rxno: item.paymentOrderNum,
                        unit: itemUnit,
                        itemName: itemName,
                        paymentRecipeId: item0.paymentRecipeId,
                        recipeType: item.recipeType,
                        medicalInsuranceType: _this.isYbScope == '2' ? '3' : medicalInsuranceType,
                        hosp_appr_flag: handleHospApprFlag(_this, item, item0),
                        min_pac_cnt: min_pac_cnt,
                        min_pacunt: min_pacunt,
                        spec: item0.specifications || '次'
                      });
                      hasSpuItemTotal += Math.min(itemTotal, spuItemTotal - hasSpuItemTotal)
                    }
                  }
                }
              })
            })
          } else if (item.recipeType == '3') {
            // 理疗
            item.items.forEach(v => {
              v.items.forEach(item0 => {
                if ((!isNull(item0.dictDrugCode) && !isNull(item0.medicalInsuranceType) && (item0.medicalInsuranceType == '2' || item0.medicalInsuranceType == '3'))) {
                  let { artNo, dictDrugCode, itemUnit, itemName, bargainTotalPrice, bargainPrice, medicalInsuranceType, min_pac_cnt, min_pacunt, ybTcDoseNum,physioExtendJson } = item0;
                  let isgt = Utils.gt(bargainTotalPrice, 0)
                  if (isgt && ybTcDoseNum && ybTcDoseNum > 0) {
                    let cnt = physioExtendJson.executionMode == '20' ? _this.$bigNumber(ybTcDoseNum,'*',physioExtendJson.onlyNum) : ybTcDoseNum
                    items.push({
                      feedetl_sn: item.paymentOrderNum,
                      med_list_codg: dictDrugCode,
                      medins_list_codg: artNo,
                      det_item_fee_sumamt:  _this.$bigNumber(bargainPrice, '*', cnt), //折后总价
                      pric: bargainPrice, //单价
                      cnt: cnt, //数量 
                      rxno: item.paymentOrderNum,
                      unit: itemUnit,
                      itemName: itemName,
                      paymentRecipeId: item0.paymentRecipeId,
                      recipeType: item.recipeType,
                      medicalInsuranceType: _this.isYbScope == '2' ? '3' : medicalInsuranceType,
                      hosp_appr_flag: handleHospApprFlag(_this, item, item0),
                      min_pac_cnt: min_pac_cnt,
                      min_pacunt: min_pacunt,
                      spec: item0.specifications || '次'
                    });
                  }
                }
              })
            })
          } else if(item.recipeType == '4' || item.recipeType == '0') {
            item.items.forEach(v => {
              v.items.forEach(item0 => {
                if ((!isNull(item0.dictDrugCode) && !isNull(item0.medicalInsuranceType) && (item0.medicalInsuranceType == '2' || item0.medicalInsuranceType == '3'))) {
                  let { artNo, dictDrugCode, itemTotal, itemUnit, itemName, bargainTotalPrice, bargainPrice, medicalInsuranceType, min_pac_cnt, min_pacunt } = item0;
                  let isgt = Utils.gt(bargainTotalPrice, 0)
                  if (isgt) {
                    items.push({
                      feedetl_sn: item.paymentOrderNum,
                      med_list_codg: dictDrugCode,
                      medins_list_codg: artNo,
                      det_item_fee_sumamt: bargainTotalPrice, //折后总价
                      pric: bargainPrice, //单价
                      cnt: itemTotal, //数量 
                      rxno: item.paymentOrderNum,
                      unit: itemUnit,
                      itemName: itemName,
                      paymentRecipeId: item0.paymentRecipeId,
                      recipeType: item.recipeType,
                      medicalInsuranceType: _this.isYbScope == '2' ? '3' : medicalInsuranceType,
                      hosp_appr_flag: handleHospApprFlag(_this, item, item0),
                      min_pac_cnt: min_pac_cnt,
                      min_pacunt: min_pacunt,
                      spec: item0.specifications || '次'
                    });
                  }
                }
              })
            })
          }
        }
      })
    }
    items.forEach((v, i) => {
      v.feedetl_sn = `${v.feedetl_sn}${i}`
    })
    console.log(items, 2222);

    return items;
  } catch (error) {
    CommonDTO.saveLogDTO({ businessType: '1', errorMsg: error.message })
  }

}
function handleHospApprFlag(_this, item, item0) {
  let hosp_appr_flag = ''
  if (_this.ybPayWay == '1' && _this.isYbScope == 1) {
    hosp_appr_flag = item0.medicalInsuranceType == '2' ? '1' : '2'
  }
  // else if (!isNull(item.processFlag) && item.processFlag == '1' && !isNullObj(item.process)) {
  //   if (item.isYlcp && item.isYlcp == '1' && item0.itemName == '加工-YL') {
  //     hosp_appr_flag = '2'
  //   }
  //   if (item.isYlcp && item.isYlcp == '0' && item0.itemName == '加工费') {
  //     hosp_appr_flag = '2'
  //   }
  // }
  else {
    hosp_appr_flag = '2'
  }
  return hosp_appr_flag
}

// 医保结算
export function settlement(_this) {
  // 信息上传接口调用
  infoUpLoad(_this);
}

//预结算
export function preSettlement(mdtrt_id, _this) {
  _this.loadingText = '预结算中'
  let preOrderParams = {
    certno: _this.yibaoObj.baseinfo.certno, //证件号码
    psn_no: _this.yibaoObj.baseinfo.psn_no, //人员编号
    mdtrt_id: mdtrt_id, //就诊编号
    mdtrt_cert_type: _this.yibaoObj.mdtrt_cert_type, //就诊凭证类型
    mdtrt_cert_no: _this.yibaoObj.mdtrt_cert_no, //就诊凭证编号
    discount_amount: 0, //优惠金额
    sum_amount: _this.yibaoObj.sum_amount, //累计金额
    card_token: _this.yibaoObj.card_token, //校验介质
    insutype: _this.yibaoObj.insuinfoObj.insutype, //险种类型
    insuplc_admdvs: _this.yibaoObj.insuinfoObj.insuplc_admdvs, //就诊人员参保地医保区划
    acct_used_flag: _this.is_wlt_acct,
    wlt_acct_flag: _this.is_wlt_acct, //钱包账户使用标志	字符型	3		Y	0 不使用 1 使用
  }
  console.log(' 预结算调用-------------------', preOrderParams)
  let param = {
    method: "post",
    url: `${_this.$shebaoUrl}/prepare_settlement`,
    data: preOrderParams,
  }
  var success = function (res) {
    if (res.data.code == 200) {
      ybPrePayObj = res.data.data
      _this.setlinfo = { ...res.data.data.setlinfo }
      _this.dialogShow = true
      _this.loading = false;
    } else {
      _this.loading = false;
    }
  }

  axios(param).then(res => {
    console.log('预结算调用完成');
    success(res);
  }).catch(err => {
    console.log('error end');
    console.log(err);
    _this.loading = false
  })
}

//查询共济关系

export function getGjRelation(_this, obj) {
  _this.gjLoadingText = '查询共济关系'
  _this.gjRelation = ''
  let paramsData = {
    psn_no: _this.yibaoObj.baseinfo.psn_no, //就医人员个人编号
    certno: obj.baseinfo.certno, //共济人证件号码
    type: 1, //绑定类型 	此处默认为1：绑定人
    insuplc_admdvs: obj.insuplc_admdvs, //员工投保区划
  }
  let param = {
    method: "post",
    url: `${_this.$shebaoUrl}/query_gj_relation`,
    data: paramsData
  }
  let success = function (res, resolve) {
    if (res.data.code == 200) {
      if (!isNull(res.data.data)) {
        _this.relationDialogShow = true
        _this.gjRelation = isEmptyArray(res.data.data.result) ? '' : res.data.data.result[0].hser_rlts
      }
    } else {
      // 失败后反向再查一次
      let paramsData2 = {
        psn_no: obj.baseinfo.psn_no,
        certno: _this.yibaoObj.baseinfo.certno, //共济人证件号码
        type: 1, //绑定类型 	此处默认为1：绑定人
        insuplc_admdvs: _this.yibaoObj.insuplc_admdvs, //员工投保区划
      }
      let param2 = {
        method: "post",
        url: `${_this.$shebaoUrl}/query_gj_relation`,
        data: paramsData2
      }
      axios(param2).then(res2 => {
        _this.relationDialogShow = true
        if (res2.data.code == 200) {
          if (!isNull(res2.data.data)) {
            let relation = isEmptyArray(res2.data.data.result) ? '' : res2.data.data.result[0].hser_rlts
            if (relation == '1') {
              _this.gjRelation = '3'
            } else if (relation == '3') {
              _this.gjRelation = '1'
            } else {
              _this.gjRelation = relation
            }
          }
        } else {
          _this.gjDialogShow = true;
          _this.gjLoading = false;
        }
      })
    }
  }
  return new Promise((resolve, reject) => {
    axios(param).then(res => { success(res, resolve) }).catch(() => {
      _this.gjDialogShow = true;
      _this.gjLoading = false;
    })
  })
}

//共济下账  预下账和下账
export function gjSettlement(_this) {
  _this.loading = true
  _this.loadingText = '共济预结算中'
  //1.先调用医保共济预下账
  //2.调用共济预支付
  //3.调用共济下账
  //4.调用支付
  let params = {
    psn_no: _this.kinsfolkObj.baseinfo.psn_no, //人员编号 
    mdtrt_cert_type: _this.kinsfolkObj.mdtrt_cert_type, //就诊凭证类型
    mdtrt_cert_no: _this.kinsfolkObj.mdtrt_cert_no, //就诊凭证编号
    insutype: _this.insutype, //险种
    acct_mulaid_pay: _this.setlinfo.psn_cash_pay, //个人账户共济支付金额
    ima_mdtrt_id: _this.setlinfo.mdtrt_id, //原主交易就诊ID 字符型	30	　	Y
    ima_setl_id: _this.setlinfo.setl_id, //原主交易结算ID 字符型	30		Y
    ima_certno: _this.setlinfo.certno, //原主交易证件号码 字符型	50		Y
    ima_med_type: _this.setlinfo.med_type, //原主交易医疗类别 字符型	6	Y Y   同med_type
    ima_medfee_sumamt: _this.setlinfo.medfee_sumamt, //原主交易医疗费总额 数值型	16,2		Y
    ima_fund_pay_sumamt: _this.setlinfo.fund_pay_sumamt, //原主交易基金支付总额 数值型	16,2	　	Y
    ima_acct_pay: _this.setlinfo.acct_pay, //原主交易个人账户支出 数值型	16,2	　	Y
    ima_psn_cash_pay: _this.setlinfo.psn_cash_pay, //原主交易个人现金支出 数值型	16,2	　	Y
    ima_psn_no: _this.setlinfo.psn_no, //原主交易个人编号 字符型	30		Y
    ima_psn_name: _this.setlinfo.psn_name, //原主交易人员姓名 字符型	50		Y
    relation: _this.gjRelation, //亲属关系 字符型	6	Y Y   与原主交易人员关系 【1:父母,2:配偶,3:子女】
    set_flag: '00', //结算标志 字符型	6	Y Y   预结正结标志 00	预结算	11	正式结算
    insuplc_admdvs: _this.kinsfolkObj.insuplc_admdvs,
    expContent: {
      card_token: _this.kinsfolkObj.card_token
    }
  }
  let preObj = {
    deptId: _this.$session.get('deptId'),
    ctOrderIds: _this.ctOrderIds,
    amount: _this.setlinfo.psn_cash_pay,
    payWay: '1',
    isMutualAidPay: true,//是否共济
  }
  let postParams = {
    method: "post",
    url: `${_this.$shebaoUrl}/gj_settlement`,
    data: params,
  }
  let success = async function (res, resolve) {
    // 2.预下账成功后调用共济预支付
    if (res.data.code === 200) {
      _this.loadingText = '数据保存中'
      preObj.attach = { ...handleSetlinfo(res.data.data.result, _this.gjRelation, _this.yibaoObj.gjInsuinfoObj), }
      let preRes = await payDTO.prePay(preObj)
      if (preRes.code === 200) {
        _this.loadingText = '共济结算中'
        params.orderPayNumber = preRes.data.orderPayNumber
        // 3.调用共济下账
        params.set_flag = '11'
        axios(postParams).then(gjRes => {
          let obj = {
            orderNumber: preRes.data.orderNumber,
            orderPayNumber: preRes.data.orderPayNumber,
            price: res.data.data.result.acct_pay,
            items: _this.yibaoObj.items,
            paySuccess: '1',
            payWay: '1'
          }
          if (gjRes.data.code === 200) {
            _this.gjSetlinfo = gjRes.data.data.result
            obj.attach = { ...handleSetlinfo(gjRes.data.data.result, _this.gjRelation, _this.yibaoObj.gjInsuinfoObj), }
            _this.$emit('yibaoPay', obj)
          } else {
            obj.paySuccess = '2'
            _this.$emit('yibaoPay', obj)
          }
        })
      } else {
        _this.gjDialogShow = true;
      }
    } else {
      _this.loading = false
      _this.loadingText = ''
      _this.gjLoading = false;
      _this.gjDialogShow = true;
    }
  }
  return new Promise((resolve, reject) => {
    //1.医保共济预下账
    axios(postParams).then(res => { success(res, resolve) })
  })
}

//查询人员信息
export function personInfo(_this) {
  _this.kinsfolkObj = {}
  _this.insuinfoList = []
  _this.insutype = ''
  _this.gjLoading = true
  _this.gjLoadingText = '查询亲属信息'
  let param = {
    method: "post",
    url: `${_this.$shebaoUrl}/person_info`,
    data: { tran_no: 'S2101' }
  }
  let success = function (res, resolve) {
    if (res.data.code == 200) {
      let insuinfoList = []
      _this.kinsfolkObj = res.data.data
      _this.kinsfolkObj.insuinfo.forEach(item => {
        insuTypeList.forEach(obj => {
          if (item.insutype == obj.code_value) {
            insuinfoList.push({
              ...item,
              label: obj.code_name
            })

          }
        })
      })
      _this.insuinfoList = insutypeSort(insuinfoList)
      _this.insutype = _this.insuinfoList[0].insutype
      getGjRelation(_this, res.data.data)
      // _this.relationDialogShow = true
    } else {
      _this.gjLoading = false
    }
  }
  return new Promise((resolve, reject) => {
    axios(param).then(res => { success(res, resolve) })
  })
}

//对险种类型进行排序
function insutypeSort(list) {
  if (isEmptyArray(list) || isNull(list)) return [];
  const sortOrder = ['310', '390', '340'];
  list.sort((a, b) => {
    const indexA = sortOrder.indexOf(a.insutype);
    const indexB = sortOrder.indexOf(b.insutype);
    // 如果 a 或 b 不在排序规则中，返回一个较大的值使其排在后面
    if (indexA === -1 && indexB === -1) {
      return 0; // 两者都不在排序规则中，保持原顺序
    } else if (indexA === -1) {
      return 1; // a 不在排序规则中，b 在排序规则中，a 排在后面
    } else if (indexB === -1) {
      return -1; // b 不在排序规则中，a 在排序规则中，b 排在后面
    } else {
      return indexA - indexB; // 两者都在排序规则中，按规则排序
    }
  })
  return list;
}


//处理医保明细字段
export function handleSetlinfo(setlinfo, relation, insuinfo) {
  let { emp_name, insuplc_admdvs } = insuinfo
  let {
    mdtrt_id,
    setl_id,
    psn_no,
    psn_name,
    psn_cert_type,
    certno,
    gend,
    naty,
    brdy,
    age,
    insutype,
    psn_type,
    cvlserv_flag,
    setl_time,
    mdtrt_cert_type,
    med_type,
    medfee_sumamt,
    fulamt_ownpay_amt,
    overlmt_selfpay,
    preselfpay_amt,
    inscp_scp_amt,
    act_pay_dedc,
    hifp_pay,
    pool_prop_selfpay,
    cvlserv_pay,
    hifes_pay,
    hifmi_pay,
    hifob_pay,
    maf_pay,
    oth_pay,
    fund_pay_sumamt,
    psn_part_amt,
    acct_pay,
    psn_cash_pay,
    hosp_part_amt,
    balc,
    acct_mulaid_pay,
    medins_setl_id,
    clr_optins,
    clr_way,
    clr_type,
    exp_content_obj
  } = setlinfo;
  let attach = {
    mdtrtId: mdtrt_id || '',
    setlId: setl_id || '',
    psnNo: psn_no || '',
    psnName: psn_name || '',
    psnCertType: psn_cert_type || '',
    certno: certno || '',
    gend: gend || '',
    naty: naty || '',
    brdy: brdy || '',
    age: age || '',
    insutype: insutype || '',
    psnType: psn_type || '',
    cvlservFlag: cvlserv_flag || '',
    setlTime: setl_time || '',
    mdtrtCertType: mdtrt_cert_type || '',
    medType: med_type || '',
    medfeeSumamt: medfee_sumamt || '',
    fulamtOwnpayAmt: fulamt_ownpay_amt || '',
    overlmtSelfpay: overlmt_selfpay || '',
    preselfpayAmt: preselfpay_amt || '',
    inscpScpAmt: inscp_scp_amt || '',
    actPayDedc: act_pay_dedc || '',
    hifpPay: hifp_pay || '',
    poolPropSelfpay: pool_prop_selfpay || '',
    cvlservPay: cvlserv_pay || '',
    hifesPay: hifes_pay || '',
    hifmiPay: hifmi_pay || '',
    hifobPay: hifob_pay || '',
    mafPay: maf_pay || '',
    othPay: oth_pay || '',
    fundPaySumamt: fund_pay_sumamt || '',
    psnPartAmt: psn_part_amt || '',
    acctPay: (acct_pay || 0) - (acct_mulaid_pay || 0) , //2026/10/19 个账金额包括个账 + 钱包
    psnCashPay: psn_cash_pay || '',
    hospPartAmt: hosp_part_amt || '',
    balc: balc || '',
    acctMulaidPay: acct_mulaid_pay || '',
    relation: relation || '',
    medinsSetlId: medins_setl_id || '',
    clrOptins: clr_optins || '',
    clrWay: clr_way || '',
    clrType: clr_type || '',
    empName: isNull(emp_name) ? '' : emp_name,
    insuplcAdmdvs: isNull(insuplc_admdvs) ? '' : insuplc_admdvs,
    wltpayAmt: acct_mulaid_pay || ''
  }
  return attach;
}

//处理退款明细字段
export function handleRefundSetlinfo(setlinfo, setldetail) {
  let {
    acct_mulaid_pay,
    acct_pay,
    act_pay_dedc,
    balc,
    clr_optins,
    cvlserv_pay,
    fulamt_ownpay_amt,
    fund_pay_sumamt,
    hifes_pay,
    hifmi_pay,
    hifob_pay,
    hifp_pay,
    hosp_part_amt,
    inscp_scp_amt,
    maf_pay,
    mdtrt_id,
    medfee_sumamt,
    medins_setl_id,
    oth_pay,
    overlmt_selfpay,
    pdn_cash_pay,
    pool_prop_selfpay,
    preselfpay_amt,
    psn_part_amt,
    setl_id,
    setl_time
  } = setlinfo
  // let setldetailArr = []
  // setldetail.forEach(item => {
  //     let { crt_payb_lmt_amt, fund_pay_type, fund_pay_type_name, fund_payamt, setl_proc_info } = item
  //     setldetailArr.push({
  //         crtPaybLmtAmt: crt_payb_lmt_amt,
  //         fundPayType: fund_pay_type,
  //         fundPayTypeName: fund_pay_type_name,
  //         fundPayamt: fund_payamt,
  //         setlProcInfo: setl_proc_info,
  //         inscpScpAmt: item.inscp_scp_amt,
  //     })
  // })

  let setlinfoObj = {
    acctMulaidPay: acct_mulaid_pay || '',
    acctPay: acct_pay || '',
    actPayDedc: act_pay_dedc || '',
    balc: balc || '',
    clrOptins: clr_optins || '',
    cvlservPay: cvlserv_pay || '',
    fulamtOwnpayAmt: fulamt_ownpay_amt || '',
    fundPaySumamt: fund_pay_sumamt || '',
    hifesPay: hifes_pay || '',
    hifmiPay: hifmi_pay || '',
    hifobPay: hifob_pay || '',
    hifpPay: hifp_pay || '',
    hospPartAmt: hosp_part_amt || '',
    inscpScpAmt: inscp_scp_amt || '',
    mafPay: maf_pay || '',
    mdtrtId: mdtrt_id || '',
    medfeeSumamt: medfee_sumamt || '',
    medinsSetlId: medins_setl_id || '',
    othPay: oth_pay || '',
    overlmtSelfpay: overlmt_selfpay || '',
    pdnCashPay: pdn_cash_pay || '',
    poolPropSelfpay: pool_prop_selfpay || '',
    preselfpayAmt: preselfpay_amt || '',
    psnPartAmt: psn_part_amt || '',
    setlId: setl_id || '',
    setlTime: setl_time || '',
  }
  return { setlinfoObj }
}

// 根据结算信息查询详细结算信息
export function querySettlementInfo(obj, _this) {
  let data = {
    mdtrt_id: obj.mdtrtId, //就诊id
    setl_id: obj.setlId, //结算id
    psn_no: obj.psnNo, //人员编号
    insuplc_admdvs: obj.insuplcAdmds
  }
  let param = {
    method: "post",
    url: `${_this.$shebaoUrl}/query_settlement_info`,
    data,
  }
  let success = function (res, resolve) {
    resolve(res.data)
  }
  let errorFun = function (err, reject) {
    reject(err)
  }
  return new Promise((resolve, reject) => {
    axios(param).then(res => { success(res, resolve) }).catch(err => { errorFun(err, reject) })
  })
}

//重试医保退款
export function ybCancelSettlement(obj, _this) {
  return new Promise((resolve, reject) => {
    let { setlId, mdtrtId, psnNo, certno, insuplcAdmds, refundNumber } = obj
    let params = {
      setl_id: setlId, // 结算ID
      mdtrt_id: mdtrtId, // 就诊ID
      psn_no: psnNo, // 人员编号
      certno: certno, // 身份证
      insuplc_admdvs: insuplcAdmds, //就诊人员参保地医保区划
      refundNumber
    };
    axios({
      method: "post",
      url: `${_this.$shebaoUrl}/repeal_settlement`,
      data: JSON.stringify(params),
    }).then(async res => {
      resolve(res.data)
    }).catch(err => {
      res.data.code == 500
      resolve(res.data)
    })
  })

}

//查询统计信息
export function queryCheckAccountTotal(obj, _this) {
  return new Promise((resolve, reject) => {
    let params = {
      psn_no: obj.baseinfo && obj.baseinfo.psn_no || '', // 人员编号
      insuplc_admdvs: obj.insuplc_admdvs, //就诊人员参保地医保区划
    };
    axios({
      method: "post",
      url: `${_this.$shebaoUrl}/query_cum`,
      data: JSON.stringify(params),
    }).then(async res => {
      if (res.data.code == 200) {
        resolve(res.data.data)
      } else {
        resolve(null)
      }
    }).catch(err => {
      resolve(null)
    })
  })
}
//人员慢特病备案查询
export function queryDisease(obj, _this) {
  return new Promise((resolve, reject) => {
    let params = {
      psn_no: obj.baseinfo && obj.baseinfo.psn_no || '', // 人员编号
      insuplc_admdvs: obj.insuplc_admdvs, //就诊人员参保地医保区划
    };
    axios({
      method: "post",
      url: `${_this.$shebaoUrl}/query_disease`,
      data: JSON.stringify(params),
    }).then(async res => {
      resolve(res.data)
    }).catch(err => {
      res.data.code == 500
      resolve(res.data)
    })
  })
}

//共济退款
export async function gjCancelSettlement(preObj, payObj, _this) {
  return new Promise((resolve, reject) => {
    let params = {
      setl_id: payObj.attach.setlId, // 结算ID
      mdtrt_id: payObj.attach.mdtrtId, // 就诊ID
      psn_no: payObj.attach.psnNo, // 人员编号
      insuplc_admdvs: payObj.attach.insuplcAdmdvs
    };
    preObj.attach = {}
    payDTO.preRefund(preObj).then(async preRes => {
      if (preRes.code == 200) {
        params.refundNumber = preRes.data.refundNumber
        // 退款
        let time = await CommonDTO.getSystemTimeDTO()
        let obj = {
          refundNumber: preRes.data.refundNumber,
          amount: preRes.data.preRefundAmount,
          refundTime: _this.$moment(time).format('YYYY-MM-DD HH:mm:ss'),
          reason: payObj.refundReason,
        }
        axios({
          method: "post",
          url: `${_this.$shebaoUrl}/gj_repeal_settlement`,
          data: JSON.stringify(params),
        }).then(async res => {
          if (res.data.code == 200) {
            obj.refundStatus = '1'
            obj.attach = handleRefundSetlinfo(res.data.data.result).setlinfoObj
            payDTO.refundCallback(obj).then(async refundRes => {
              if (refundRes.code == 200) {
                _this.$message.success('医保共济退款成功！')
                resolve()
              } else {
                _this.loading = false
                _this.$message.error('医保退费失败，请到退费管理重试')
                _this.$emit('updateData')
              }
            })
          } else {
            obj.refundStatus = '2'
            obj.attach = {}
            payDTO.refundCallback(obj).then(async refundRes => { })
            _this.loading = false
          }
        }).catch(err => {
          obj.refundStatus = '2'
          obj.attach = {}
          payDTO.refundCallback(obj).then(async refundRes => { })
          _this.loading = false
          _this.$message.error('医保退费失败，请到退费管理重试')
          _this.$emit('updateData')
        })
      } else {
        _this.loading = false
      }
    })
  })

}
//重试共济退款
export function ybGjCancelSettlement(obj, _this) {
  return new Promise((resolve, reject) => {
    let { setlId, mdtrtId, psnNo, refundNumber, insuplcAdmds } = obj
    let params = {
      setl_id: setlId, // 结算ID
      mdtrt_id: mdtrtId, // 就诊ID
      psn_no: psnNo, // 人员编号
      refundNumber,
      insuplc_admdvs: insuplcAdmds
    };
    axios({
      method: "post",
      url: `${_this.$shebaoUrl}/gj_repeal_settlement`,
      data: JSON.stringify(params),
    }).then(async res => {
      resolve(res.data)
    }).catch(err => {
      res.data.code == 500
      resolve(res.data)
    })
  })
}
async function handleBeforeAnalyzeParams(_this) {
  let durgList = handleItems(_this)
  let hilist_code = []
  let patient_dtos = []
  let fsi_diagnose_dtos = []
  diseinfos.forEach((item, index) => {
    fsi_diagnose_dtos.push({
      dise_id: index,//诊断标识 
      inout_dise_type: 1,//出入诊断类别 码值INOUT_DIAG_TYPE
      maindise_flag: 1, //主诊断标志 码值 MAINDIAG_FLAG
      dias_srt_no: index,//诊断排序号
      dise_codg: item.diag_code,//诊断(疾病)编码
      dise_name: item.diag_name,//诊断(疾病)名称
      dise_date: _this.$timeRange.nowTimes,//诊断日期 n
    })
  })
  durgList.forEach(item => {
    hilist_code.push(item.med_list_codg)
  })
  const reim_flag_map = {
    '2': '4',
    '3': '2',
    '4': '3'
    // 本地病人传2，省内异地传3，跨省传4
  }
  let mdtrtareaAdmvs = _this.$session.get('deptInfo').chsInfo.mdtrtareaAdmvs
  let insu_admdvs = `${mdtrtareaAdmvs.substring(0, 4)}00`
  let { code, data } = await queryDrug({ insu_admdvs, hilist_code })
  if (code == 200) {
    let list = []
    data && data.forEach(v1 => {
      durgList.forEach(v2 => {
        if (v1.hilist_code == v2.med_list_codg && isNull(v1.enddate)) {
          list.push({ ...v1, ...v2 })
        }
      })
    })
    let recipesObj = _this.$lodash.groupBy(list, 'rxno')
    for (const key in recipesObj) {
      let fsi_order_dtos = [] //处方(医嘱)信息
      let fsi_encounter_dtos = []//就诊信息集合
      let medfee_sumamt = 0
      recipesObj[key].forEach(v1 => {
        medfee_sumamt = _this.$bigNumber(medfee_sumamt, '+', v1.pric, 2)
        fsi_order_dtos.push({
          rx_id: v1.feedetl_sn,//处方标识
          rxno: v1.rxno,//处方号
          grpno: '',//组编号 n
          long_drord_flag: 0,//是否为长期医嘱 1=是,0=否
          hilist_type: v1.list_type,//目录类别 码值 LIST_TYPE
          chrg_type: v1.med_chrgitm_type,//收费类别 码值 MED_CHRGITM_TYPE
          drord_bhvr: '0',//医嘱行为 0= 其他,1=出院带药
          hilist_code: v1.med_list_codg,//医保目录代码
          hilist_name: v1.hilist_name,//医保目录名称
          hilist_dosform: '中药饮片',//医保目录(药 品)剂型 n
          hilist_lv: v1.chrgitm_lv,//医保目录等级 
          hilist_pric: Utils.toFixed(v1.pric, 2),//医保目录价格
          lv1_hosp_item_pric: '',//一级医院目 录价格 n
          lv2_hosp_item_pric: '',//二级医院目 录价格 n
          lv3_hosp_item_pric: '',//三级医院目 录价格 n
          hilist_memo: '',//医保目录备注 n
          hosplist_code: v1.medins_list_codg,//医院目录代码
          hosplist_name: v1.itemName,//医院目录名称
          hosplist_dosform: '中药饮片',//医院目录(药 品)剂型 n
          cnt: v1.cnt,//数量
          pric: Utils.toFixed(v1.pric, 2),//单价
          sumamt: v1.det_item_fee_sumamt,//总费用
          ownpay_amt: '',//自费金额 n
          selfpay_amt: '',//自付金额 n
          spec: v1.spec,//规格
          spec_unt: v1.unit,//数量单位
          drord_begn_date: _this.$timeRange.nowTimes,//医嘱开始日期
          drord_stop_date: '',//医嘱结束日期 n
          drord_dept_codg: 'ZYK',//下达医嘱的科室标识
          drord_dept_name: '中医科',//下达医嘱的科室名称
          drord_dr_codg: _this.yibaoObj.doctorCode,//医嘱的医师标识
          drord_dr_name: _this.yibaoObj.doctorName,//医嘱的医师名称
          drord_dr_profttl: '3',//开处方(医嘱)医职称 码值DR_PRO_TECH_DUTY
          curr_drord_flag: 1,//当前医嘱标志 1=是,0= 否
          extend_order_map: {},//处方扩展属性 n
        })
      })
      fsi_encounter_dtos[0] = {
        mdtrt_id: _this.request_2204Obj.request_2204[0].mdtrt_id,//就诊ID
        medins_id: _this.$session.get('deptInfo').chsInfo.ybDeptNum,//医保机构ID
        medins_name: _this.$session.get('deptInfo').chsInfo.mdtrtareaAdmvs,//医保机构名称
        medins_admdvs: _this.$session.get('deptInfo').chsInfo.mdtrtareaAdmvs,//医疗机构行政区划编码
        medins_type: _this.$session.get('deptInfo').chsInfo.medinsType,//医疗服务机构类型  码值 MEDINS_TYPE
        medins_lv: _this.$session.get('deptInfo').chsInfo.hospLv,//医疗机构等级 码值 HOSP_LV
        wardarea_codg: '',//病区标识 N 
        wardno: '',//病房号 n
        bedno: '',//病床号 n
        adm_date: _this.$timeRange.nowTimes,//入院日期
        dscg_date: '',//出院日期 n
        dscg_main_dise_codg: diseinfos[0].diag_code,//主诊断编码
        dscg_main_dise_name: diseinfos[0].diag_name,//主诊断名称
        fsi_diagnose_dtos: fsi_diagnose_dtos,//诊断信息 DTO
        dr_codg: _this.yibaoObj.doctorCode,//医师标识
        adm_dept_codg: 'ZYK',//入院科室标识
        adm_dept_name: '中医科',//入院科室名称
        dscg_dept_codg: 'ZYK',//出院科室标识 n
        dscg_dept_name: '中医科',//出院科室名称 n
        med_mdtrt_type: 1,//就诊类型 码值 MED_MDTRT_TYPE
        med_type: '11', //医疗类别 码值 MED_TYPE
        fsi_order_dtos: fsi_order_dtos,//处方(医嘱)信息
        matn_stas: 0,// 生育状态 参考字典-[0= 其他,1=妊娠期,2= 哺乳期]
        medfee_sumamt: medfee_sumamt,//总费用 n
        ownpay_amt: '',//自费金额 n
        selfpay_amt: '',//自付金额 n
        acct_payamt: '', //个人账户支付金额 n
        ma_amt: '', //救助金支付金额 n
        hifp_payamt: '',//统筹金支付金额 n
        setl_totlnum: '1',//结算总笔数
        insutype: _this.yibaoObj.insuinfoObj.insutype,//险种 码值 INSUTYPE 
        reim_flag: reim_flag_map[jugeDistrict(_this).value],//报销标志 码值 PAY_LOC n 本地病人传2，省内异地传3，跨省传4，
        out_setl_flag: '',//异地结算标志 码值 PAY_LOC n
        fsi_operation_dtos: [], //手术操作集合 n
        dise_no: '',//病种编号 n
        dise_name: '',//病种名称 n
        sinc_heal_lv: '',//手术切口愈合等级 n
        his_md_cnt: '',//历史就诊次数 n
      }
      patient_dtos.push({
        patn_id: _this.yibaoObj.baseinfo.psn_no,//参保人标识
        patn_name: _this.yibaoObj.baseinfo.psn_name,//参保人姓名
        gend: _this.yibaoObj.baseinfo.gend,//性别 1:男 2:女
        brdy: _this.yibaoObj.baseinfo.brdy,//出生日期
        poolarea: jugeDistrict(_this).value == '3' ? _this.yibaoObj.insuinfoObj.insuplc_admdvs : '511300',//参保人所属统筹区
        curr_mdtrt_id: recipesObj[key][0].rxno,//本次就诊记录唯一ID
        fsi_encounter_dtos: fsi_encounter_dtos,
      })
    }
  }

  return patient_dtos
}
//事前提醒
async function beforeAnalyze(_this) {
  let obj = {
    trig_scen: 7, //触发场景
    insuplc_admdvs: jugeDistrict(_this).value == '3' ? _this.yibaoObj.insuinfoObj.insuplc_admdvs : '511300',
    patient_dtos: await handleBeforeAnalyzeParams(_this)
  }
  let param = {
    method: "post",
    url: `${_this.$shebaoUrl}/3101`,
    data: obj,
  }
  return new Promise((resolve, reject) => {
    axios(param).then(res => {
      if (res.data.code == 200) {
        let { result } = res.data.data
        if (!isNull(result) && result.length > 0) {
          _this.loading = false
          _this.beforeAnalyzeShow = true
          _this.beforeAnalyzeResult = result
          resolve(false)
        } else {
          resolve(true)
        }
      } else {
        msgboxWarning(_this, {
          message: `事前服务不可用，刷医保可能有违规风险，是否继续？`,
          confirmFn: () => {
            resolve(true)
          },
          cancelFn: () => {
            resolve(false)
            _this.loading = false
          },
        });
      }
    }).catch(err => {
      msgboxWarning(_this, {
        message: `事前服务不可用，刷医保可能有违规风险，是否继续？`,
        confirmFn: () => {
          resolve(true)
        },
        cancelFn: () => {
          resolve(false)
          _this.loading = false
        },
      });
    })
  })
}
//事前事中服务反馈服务
export function feedback(warns, _this) {
  let param = {
    method: "post",
    url: `${_this.$shebaoUrl}/3103`,
    data: { warn_type: '1', warns },
  }
  return new Promise((resolve, reject) => {
    axios(param).then(res => {
      if (res.data.code == 200) {
        resolve(true)
      } else {
        resolve(false)
      }
    }).catch(err => {
      resolve(false)
    })
  })
}

function jugeDistrict(_this) {
  let obj = {}
  let insuplc_admdvs = _this.yibaoObj.insuinfoObj.insuplc_admdvs // 刷卡人参保地 510100
  let mdtrtareaAdmvs = _this.$session.get('deptInfo').chsInfo.mdtrtareaAdmvs // 机构所在地 511302
  if ("519900" === insuplc_admdvs) {
    obj.value = 1
    obj.text = '省卡'
  } else {
    // 前4位 
    let a = mdtrtareaAdmvs.substr(0, 4);
    let b = insuplc_admdvs.substr(0, 4);

    // 前2位
    let c = mdtrtareaAdmvs.substr(0, 2);
    let d = insuplc_admdvs.substr(0, 2);
    if (c === d) {
      if (a === b) {
        obj.value = 3
        obj.text = '市本地'
      } else {
        obj.value = 4
        obj.text = '省内异地'
      }
    } else {
      obj.value = 2
      obj.text = '省外异地'
    }
  }
  console.log(obj, 1111);
  return obj;
}